export default {
    required: "Es wird ein Wert benötigt.",
    email: "Der Wert ist keine gültige E-Mail-Adresse.",
    mask: "Der Wert ist ungültig.",
    maxValue: "Der Maximalwert ist {max}",
    maxLength: "Die maximal zulässige Länge ist {max}",
    regex: "Der Wert ist ungültig.",
    server: {
        DELEGATES_NOT_ENABLED: "Für diesen Partner sind keine Delegierten aktiviert.",
        DELEGATE_DOES_NOT_EXIST: "Es existiert kein Delegierter.",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "Ein Delegierter, der Ihnen nicht gehört, kann nicht aktualisiert werden.",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "Ein Delegierter, der Ihnen nicht gehört, kann nicht gelöscht werden.",
        DELEGATE_ALREADY_EXISTS: "Eine bestehende Delegiertenregel, die diesen Kriterien entspricht, existiert bereits.",
        DELEGATE_CANNOT_BE_SELF: "Sie können sich nicht selbst als Delegierten hinzufügen.",
        IMPERSONATE_USER_NO_PERMISSIONS: "Benutzer {email} hat keinen Zugriff auf DXC-Geräte und kann keine Bestellung in seinem Namen aufgeben.",
        INVALID_CART_ITEM: "Produkt {product} nicht erlaubt",
        INVALID_USER_TYPE: "Der Benutzertyp ist kein Mitarbeiter.",
        INVALID_EMPLOYMENT_STATUS: "Der Nutzer ist kein aktiver Mitarbeiter.",
        USER_NOT_FOUND: "Benutzer nicht gefunden",
        "Invalid user type": "Ungültiger Benutzertyp",
        "User not found": "Benutzer nicht gefunden"
    }
}